module.exports = __webpack_public_path__ + "fonts/RobotoMono-LightItalic.547082bb.woff2";